import API from '../../services/api';

export const fetchPermissionSets = async (params = {}) => {
  // params may include { scope, search, page, limit }
  const res = await API.get('/permission-sets/get', { params });
  return res.data;
};

// Module/field catalog (source of truth) for the authoring UI.
export const fetchPermissionCatalog = async () => {
  const res = await API.get('/permission-sets/catalog');
  return res.data; // { modules: [...], catalog: {...} }
};

// Assign group/role sets and/or a user override to a user.
// Pass overrideId:null to clear the override.
export const assignPermissionsToUser = async ({ userId, groupIds, overrideId }) => {
  const res = await API.put('/permission-sets/assign', { userId, groupIds, overrideId });
  return res.data;
};

// Preview a user's effective (merged) permissions.
export const fetchEffectivePermissions = async (userId) => {
  const res = await API.get(`/permission-sets/effective/${userId}`);
  return res.data; // { userId, permissions: [...] }
};

export const fetchPermissionSetById = async (id) => {
  const res = await API.get(`/permission-sets/${id}`);
  return res.data;
};

export const createPermissionSet = async (data) => {
  const res = await API.post('/permission-sets/create', data);
  return res.data;
};

export const updatePermissionSet = async (id, data) => {
  const res = await API.put(`/permission-sets/${id}`, data);
  return res.data;
};

export const deletePermissionSet = async (id) => {
  const res = await API.delete(`/permission-sets/${id}`);
  return res.data;
};

export const fetchUsers = async ({
  search = '',
  page = 1,
  limit = 10,
  role = null,
  status = null,
  sortField = null,
  sortOrder = null,
}) => {
  try {
    const params = {
      page,
      limit,
    };

    if (search && search.trim() !== '') {
      params.search = search.trim();
    }

    if (role) {
      params.role = role;
    }

    if (status) {
      params.status = status;
    }

    if (sortField) {
      params.sortField = sortField;
    }

    if (sortOrder) {
      params.sortOrder = sortOrder;
    }

    const response = await API.get('/users', { params });

    return response.data; // expecting { data: [...], meta: {...} }
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

export const fetchUserById = async (userId) => {
  try {
    const response = await API.get(`/users/${userId}`);
    return response.data; // expecting user object
  } catch (error) {
    console.error('Error fetching user:', error);
    throw error;
  }
};